import apiClient from "../api/client";

import { signUp } from "../constants/actionTypes";

// Profession and community lookups for the public profession pages. The account sign-up action that lived here
// (and its /create-new-account page) was removed in GROWTH-8100: members register in Keycloak.
export const actions = {
  getPublicProfessions(profession, isNotLoadDetail) {
    return dispatch => {
      dispatch({ type: signUp.GET_PROFESSIONS_LOADING });
      apiClient({
        method: "get",
        url: "/members/json-api/public/professions"
      })
        .then(result => {
          dispatch({ type: signUp.GET_PROFESSIONS_LIST, payload: result.data });
          const findActiveProfession = result.data.find(item => item.title.toLowerCase() === profession);

          if (!isNotLoadDetail) {
            dispatch(this.getProfessionList(findActiveProfession.profession_id));
          }
        })
        .catch(error => {
          dispatch({ type: signUp.GET_PROFESSIONS_FAIL, payload: error.response ? error.response.data.error : "Server error" });
        });
    };
  },

  getCountries(profession) {
    return dispatch => {
      dispatch({ type: signUp.GET_PROFESSIONS_LOADING });

      apiClient({
        method: "get",
        url: "/members/json-api/public/heritages"
      })
        .then(result => {
          const findActiveProfession = result.data.find(item => item.title.toLowerCase() === profession);

          dispatch({ type: signUp.GET_COUNTRIES_LIST, payload: result.data });
          if (findActiveProfession) {
            dispatch(this.getPublicCountryCommunities(findActiveProfession.heritage_id));
          }
        })
        .catch(error => {
          dispatch({ type: signUp.GET_COUNTRIES_LIST_FAIL, payload: error.response ? error.response.data.error : "Server error" });
        });
    };
  },

  getProfessionList(professionId) {
    return dispatch => {
      apiClient({
        method: "get",
        url: `/members/json-api/directory/by-profession?profession_id=${professionId}`
      })
        .then(result => {
          dispatch({ type: signUp.GET_PROFESSIONS, payload: result.data });
        })
        .catch(error => {
          dispatch({ type: signUp.GET_PROFESSIONS_FAIL, payload: error.response ? error.response.data.error : "Server error" });
        });
    };
  },

  getPublicCountryCommunities(professionId) {
    return dispatch => {
      apiClient({
        method: "get",
        url: `/members/json-api/public/communities?heritage_id=${professionId}`
      })
        .then(result => {
          dispatch({ type: signUp.GET_PROFESSIONS, payload: result.data });
        })
        .catch(error => {
          dispatch({ type: signUp.GET_PROFESSIONS_FAIL, payload: error.response ? error.response.data.error : "Server error" });
        });
    };
  },

  cleanProfessional() {
    return dispatch => {
      dispatch({ type: signUp.CLEAN_PROFESSIONAL });
    };
  }
};
